module.exports = __webpack_public_path__ + "static/media/Brunei.ea89abad.png";